export default "__VITE_ASSET__BMdtVlxn__"